import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import jwtAuthAxios, {setTokenManual} from "../../services/jwtAuth";
import registerAxios from "../../services/jwtAuth";
import jwtAuth from "../../services/jwtAuth";
import axios from "axios";
export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	impersonating: localStorage.getItem('imp_active') === 'true',
	impersonatedUser: localStorage.getItem('imp_username') || ''
}
export const signIn =
	createAsyncThunk('auth/signIn',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		let loginCreds = {email, password};
		const response = await jwtAuthAxios.post('/v1/auth/authenticate', loginCreds);
		if (response.data) {
			//console.log("response.data : ",JSON.stringify(response.data))
			if (response.data.result) {
				const token = response.data.token.access_token;
				const roles = response.data.roles;
				localStorage.setItem(AUTH_TOKEN, token);
				localStorage.setItem('roles', roles);
				localStorage.setItem('user_id', response.data.user_id);
				localStorage.setItem('camaba_id', response.data.camaba_id);
				localStorage.setItem('registration_id', response.data.registration_id);
				localStorage.setItem('prodi_id', response.data.prodi_id);
				setTokenManual(token);
				return token;
			} else {
				return rejectWithValue('Not Authorize');
			}
		} else {
			//return rejectWithValue(response.message?.replace('Firebase: ', ''));
			return rejectWithValue('Not Authorize');
		}
	} catch (err) {
		return rejectWithValue('Not Authorize');
	}
})


export const signUp =
	createAsyncThunk('auth/signUp',async (data, { rejectWithValue }) => {
	const { firstName,lastName,email, password,role,mobilePhone } = data
	try {
		let loginCreds = {firstName,lastName,email, password,role,mobilePhone};
		const response = await axios.post('/pmb/auth/register', loginCreds);
		return response.data;
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

// Key localStorage untuk membackup sesi admin saat impersonate berlangsung
const IMP_KEYS = {
	active: 'imp_active',
	username: 'imp_username',
	token: 'imp_admin_token',
	roles: 'imp_admin_roles',
	userId: 'imp_admin_user_id',
	camabaId: 'imp_admin_camaba_id',
	registrationId: 'imp_admin_registration_id',
	prodiId: 'imp_admin_prodi_id',
}

export const impersonate =
	createAsyncThunk('auth/impersonate',async ({ userId, username }, { rejectWithValue }) => {
	try {
		const adminToken = localStorage.getItem(AUTH_TOKEN);
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + adminToken;
		const response = await jwtAuthAxios.post(`v1/users/impersonate/${userId}`);
		if (response.data && response.data.result) {
			// Backup sesi admin agar bisa kembali nanti
			localStorage.setItem(IMP_KEYS.token, adminToken);
			localStorage.setItem(IMP_KEYS.roles, localStorage.getItem('roles') || '');
			localStorage.setItem(IMP_KEYS.userId, localStorage.getItem('user_id') || '');
			localStorage.setItem(IMP_KEYS.camabaId, localStorage.getItem('camaba_id') || '');
			localStorage.setItem(IMP_KEYS.registrationId, localStorage.getItem('registration_id') || '');
			localStorage.setItem(IMP_KEYS.prodiId, localStorage.getItem('prodi_id') || '');
			localStorage.setItem(IMP_KEYS.active, 'true');
			localStorage.setItem(IMP_KEYS.username, username || '');

			// Pasang sesi user yang diimpersonate
			const token = response.data.token.access_token;
			localStorage.setItem(AUTH_TOKEN, token);
			localStorage.setItem('roles', response.data.roles);
			localStorage.setItem('user_id', response.data.user_id);
			localStorage.setItem('camaba_id', response.data.camaba_id);
			localStorage.setItem('registration_id', response.data.registration_id);
			localStorage.setItem('prodi_id', response.data.prodi_id);
			setTokenManual(token);
			return { token, username: username || '' };
		}
		return rejectWithValue('Impersonate gagal');
	} catch (err) {
		return rejectWithValue('Impersonate gagal');
	}
})

export const exitImpersonate =
	createAsyncThunk('auth/exitImpersonate',async (_, { rejectWithValue }) => {
	try {
		const adminToken = localStorage.getItem(IMP_KEYS.token);
		if (!adminToken) {
			return rejectWithValue('Sesi admin tidak ditemukan');
		}
		// Pulihkan sesi admin
		localStorage.setItem(AUTH_TOKEN, adminToken);
		localStorage.setItem('roles', localStorage.getItem(IMP_KEYS.roles) || '');
		localStorage.setItem('user_id', localStorage.getItem(IMP_KEYS.userId) || '');
		localStorage.setItem('camaba_id', localStorage.getItem(IMP_KEYS.camabaId) || '');
		localStorage.setItem('registration_id', localStorage.getItem(IMP_KEYS.registrationId) || '');
		localStorage.setItem('prodi_id', localStorage.getItem(IMP_KEYS.prodiId) || '');
		// Bersihkan backup
		Object.values(IMP_KEYS).forEach(k => localStorage.removeItem(k));
		setTokenManual(adminToken);
		return adminToken;
	} catch (err) {
		return rejectWithValue('Gagal keluar dari impersonate');
	}
})

export const signOut = createAsyncThunk('auth/signOut',async () => {
    const response = await FirebaseService.signOutRequest()
	localStorage.removeItem(AUTH_TOKEN);
	localStorage.removeItem("roles");
    return response.data
})

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/auth/login'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(impersonate.pending, (state) => {
				state.loading = true
			})
			.addCase(impersonate.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload.token
				state.impersonating = true
				state.impersonatedUser = action.payload.username
			})
			.addCase(impersonate.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(exitImpersonate.pending, (state) => {
				state.loading = true
			})
			.addCase(exitImpersonate.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
				state.impersonating = false
				state.impersonatedUser = ''
			})
			.addCase(exitImpersonate.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				//state.redirect = '/'
				//state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const { 
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer
